// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"297":"library","328":"admin","501":"public","871":"legal","995":"management"}[chunkId] || chunkId) + "." + {"297":"b0fbe5ab","328":"4d33ccc2","501":"dfdc128c","659":"0cc4632e","871":"efe68602","995":"9885e9c2"}[chunkId] + ".css";
};